import LuxPlusLabelWithModal from 'luxPlus/components/LuxPlusLabelWithModal'
import { useIntl } from 'react-intl'
import formatOfferInclusionDescription from 'lib/offer/formatOfferInclusionDescription'

interface Props {
  luxPlusInclusions: Array<App.PackageInclusion>
  offer?: App.CruiseOffer
  isModalPrimaryActionHidden?: boolean
}

function CruiseLuxPlusOnboardCreditLabel(props: Props) {
  const { luxPlusInclusions, offer, isModalPrimaryActionHidden } = props
  const firstLuxPlusInclusion = luxPlusInclusions[0]
  const intl = useIntl()

  return <>
    {!!firstLuxPlusInclusion && <LuxPlusLabelWithModal
      type="bonus-inclusions"
      inclusionDescription={formatOfferInclusionDescription(firstLuxPlusInclusion.description, intl)}
      inclusions={luxPlusInclusions}
      offer={offer}
      isModalPrimaryActionHidden={isModalPrimaryActionHidden}
    />}
  </>
}

export default CruiseLuxPlusOnboardCreditLabel
